import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ebd6f67c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "checkbox-wrapper" }
const _hoisted_2 = ["id", "checked"]
const _hoisted_3 = ["for"]
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" ")

interface IPropsTheInput {
    id: string
    text?: string
    modelValue?: boolean
}

interface IEventTheInput {
    (e: 'change', checked: boolean): void
    (e: 'update:modelValue', checked: boolean): void
}


export default /*#__PURE__*/_defineComponent({
  props: {
    id: { type: String, required: true, default: 'checkboxId' },
    text: { type: String, required: false, default: '' },
    modelValue: { type: Boolean, required: false, default: false }
  },
  emits: ["change", "update:modelValue"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'change', checked: boolean): void
    (e: 'update:modelValue', checked: boolean): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { id: string, text: string, modelValue: boolean }




const onChange = () => {
    emit('change', !props.modelValue)
    emit('update:modelValue', !props.modelValue)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("input", {
      id: props.id,
      class: "checkbox-wrapper__input",
      checked: props.modelValue,
      type: "checkbox",
      onChange: onChange
    }, null, 40, _hoisted_2),
    _createElementVNode("label", {
      class: "checkbox-wrapper__label",
      for: props.id
    }, [
      _hoisted_4,
      _renderSlot(_ctx.$slots, "default")
    ], 8, _hoisted_3)
  ]))
}
}

})